 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ActivityApply":"ActivityApply","DetailCompanyProduct":"DetailCompanyProduct","DetailCompanyType":"DetailCompanyType","Message":"Message","MoblieMessage":"MoblieMessage","MyFollower":"MyFollower","ScratchAllWorksContainer":"ScratchAllWorksContainer","VideoCourse":"VideoCourse","Works":"Works","about":"about","ActivityDetail":"ActivityDetail","CommentMessage":"CommentMessage","LikeMessage":"LikeMessage","MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage":"MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage","MoblieCommentMessage":"MoblieCommentMessage","MoblieLikeMessage":"MoblieLikeMessage","MoblieNotificationMessage":"MoblieNotificationMessage","NotificationMessage":"NotificationMessage","AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail":"AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail","AttentionMessage":"AttentionMessage","PostDetail":"PostDetail","DetailCompany":"DetailCompany","Profile":"Profile","SchoolDetail":"SchoolDetail","Home":"Home","MoblieAttentionMessage":"MoblieAttentionMessage"}[chunkId]||chunkId) + "." + {"ActivityApply":"011d76ce","DetailCompanyProduct":"9c300f74","DetailCompanyType":"95349f3e","Message":"483feb69","MoblieMessage":"098eb64c","MyFollower":"461fbd7d","ScratchAllWorksContainer":"14e7f7ce","VideoCourse":"e00fadaf","Works":"8d0703f4","about":"4589746e","chunk-2d21d0c2":"d0a8aed7","chunk-5e62f9b3":"67a0c706","chunk-32128279":"9383a4c4","ActivityDetail":"ecc684f8","CommentMessage":"c0aeda71","LikeMessage":"b62648bd","MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage":"5ce69516","MoblieCommentMessage":"6d8d0953","MoblieLikeMessage":"f7750d9f","MoblieNotificationMessage":"b7718dca","NotificationMessage":"6ef3c6c0","chunk-2dbe63cf":"5c921361","AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail":"0dfb0cd8","AttentionMessage":"6cbcf24d","chunk-18243601":"f5674417","PostDetail":"ba8bd3f8","DetailCompany":"8f767414","Profile":"ce4ec572","SchoolDetail":"45fe6a16","chunk-7fab3bda":"4fc27f04","Home":"e419f06c","MoblieAttentionMessage":"6c285238","chunk-4965b062":"1d25b4ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ActivityApply":1,"DetailCompanyProduct":1,"DetailCompanyType":1,"Message":1,"MoblieMessage":1,"MyFollower":1,"ScratchAllWorksContainer":1,"VideoCourse":1,"Works":1,"chunk-5e62f9b3":1,"chunk-32128279":1,"ActivityDetail":1,"CommentMessage":1,"LikeMessage":1,"MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage":1,"MoblieCommentMessage":1,"MoblieLikeMessage":1,"MoblieNotificationMessage":1,"NotificationMessage":1,"chunk-2dbe63cf":1,"AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail":1,"AttentionMessage":1,"chunk-18243601":1,"PostDetail":1,"DetailCompany":1,"Profile":1,"SchoolDetail":1,"chunk-7fab3bda":1,"Home":1,"MoblieAttentionMessage":1,"chunk-4965b062":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ActivityApply":"ActivityApply","DetailCompanyProduct":"DetailCompanyProduct","DetailCompanyType":"DetailCompanyType","Message":"Message","MoblieMessage":"MoblieMessage","MyFollower":"MyFollower","ScratchAllWorksContainer":"ScratchAllWorksContainer","VideoCourse":"VideoCourse","Works":"Works","about":"about","ActivityDetail":"ActivityDetail","CommentMessage":"CommentMessage","LikeMessage":"LikeMessage","MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage":"MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage","MoblieCommentMessage":"MoblieCommentMessage","MoblieLikeMessage":"MoblieLikeMessage","MoblieNotificationMessage":"MoblieNotificationMessage","NotificationMessage":"NotificationMessage","AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail":"AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail","AttentionMessage":"AttentionMessage","PostDetail":"PostDetail","DetailCompany":"DetailCompany","Profile":"Profile","SchoolDetail":"SchoolDetail","Home":"Home","MoblieAttentionMessage":"MoblieAttentionMessage"}[chunkId]||chunkId) + "." + {"ActivityApply":"17252e95","DetailCompanyProduct":"ddd811be","DetailCompanyType":"53c1a833","Message":"974f2f22","MoblieMessage":"47ee8337","MyFollower":"22f395cb","ScratchAllWorksContainer":"a7dcbb02","VideoCourse":"06d57f14","Works":"79ae48d3","about":"31d6cfe0","chunk-2d21d0c2":"31d6cfe0","chunk-5e62f9b3":"fead1838","chunk-32128279":"05d868ad","ActivityDetail":"a86c988f","CommentMessage":"d63ba63b","LikeMessage":"9676f45a","MoblieAttentionMessage~MoblieCommentMessage~MoblieLikeMessage~MoblieNotificationMessage":"1ca55f56","MoblieCommentMessage":"8189bea9","MoblieLikeMessage":"02cc3041","MoblieNotificationMessage":"7f358f37","NotificationMessage":"750e686c","chunk-2dbe63cf":"1e531906","AttentionMessage~DetailCompany~Home~PostDetail~Profile~SchoolDetail":"775a6843","AttentionMessage":"9bc6923e","chunk-18243601":"3a8d2699","PostDetail":"c8bfdf62","DetailCompany":"b3c34b7f","Profile":"948b5ddc","SchoolDetail":"c752b527","chunk-7fab3bda":"d8665ac6","Home":"473746d7","MoblieAttentionMessage":"3ad2586e","chunk-4965b062":"f4cc41aa"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/community/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
